import React from 'react';
//import Header from '@/components/header';
import { SafeAreaView } from 'react-native-safe-area-context';
import HomeScreenComponent from '@/components/Homescreen';

export default function HomeScreen() {
  return (
    <SafeAreaView style={{ width:'100%', flex: 1, margin:0, padding: 0 }}>
      <HomeScreenComponent />
    </SafeAreaView>
  );
}